<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {} from 'devextreme-vue/data-grid';
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import Swal from "sweetalert2";
import moment from "moment/moment";
import {
  GridComponent, ColumnsDirective, ColumnDirective,
  Page, Filter, Toolbar
} from '@syncfusion/ej2-vue-grids';
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  provide: {
    grid: [Page, Filter, Toolbar ]
  },
  data() {

    return {
      title: "Editar Minuta",
      items: [
        {
          text: "Minutas",
          href: "/minutas/list"
        },
        {
          text: "Editar Minuta",
          active: true
        }
      ],
      idData: 0,
      updating: false,
      errosValid: null,
      submitted: false,
      minutaData: {
        'emissao': moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        'remetipo': 'PJ',
        'destipo': 'PJ',
        'expedtipo': 'PJ',
        'entrtipo': 'PJ',
        'tipoemis': 'ENT',
        'aliquota': 4
      },

      dtListPesqMov: null,
      loadingRemet: false,
      loadingDest: false,
      loadingExped: false,
      loadingEntr: false,

      showModalMinutaDoc: false,
      minutaDocData: {},
      minutaDocsData: null,
      submittedMinutaDoc: false,

      showModalMinutaItem: false,
      minutaItemData: {},
      minutaItensData: {},
      submittedMinutaItem: false,

      showModalMinutaLacre: false,
      minutaLacreData: {},
      minutaLacresData: {},
      submittedMinutaLacre: false,

      showModalMinutaMemo: false,
      minutaMemoData: {},
      minutaMemosData: {},
      submittedMinutaMemo: false,

      loadingChaveDoc: false,

      showModalPesqCotacao: false,
      showModalPesqPessoa: false,

      cotacoesData: null,
      pessoasData: null,
      origemPessoasPesq: null,
      loadingCliente: null,

      showModalPesqFormaPgto: false,
      formaPgtosData: null,

      empresasData: null,
      showModalPesqEmpresa: null,
      cidadesData: null,
      showModalPesqCidade: null,
      origemCidadesPesq: null,

      toolbar: [{text: 'Search', tooltipText: 'Pesquisar'}],
      minutaDefServs: null,
      minutaDefItensAdics: null,
      minutaDefTrechos: null,
      minutaDefVeics: null,

    };
  },

  watch: {
    'minutaItemData.quant': function(newValue) {
      if (newValue && this.minutaItemData.valorun) {
        this.minutaItemData.valortot = (parseFloat(newValue) * parseFloat(this.minutaItemData.valorun)).toFixed(2)
      }
    },
    'minutaItemData.valorun': function(newValue) {
      if (newValue && this.minutaItemData.vlrunit) {
        this.minutaItemData.valortot = (parseFloat(newValue) * parseFloat(this.minutaItemData.quant)).toFixed(2)
      }
    },

    'minutaData.txcoleta': 'calculaTotal',
    'minutaData.txentrega': 'calculaTotal',
    'minutaData.txpedagio': 'calculaTotal',
    'minutaData.txtad': 'calculaTotal',
    'minutaData.txgris': 'calculaTotal',
    'minutaData.txpesoadic': 'calculaTotal',
    'minutaData.txdespacho': 'calculaTotal',
    'minutaData.txredesp': 'calculaTotal',
    'minutaData.txoutras': 'calculaTotal',
    'minutaData.txtas': 'calculaTotal',
    'minutaData.txtrt': 'calculaTotal',
    'minutaData.txtde': 'calculaTotal',
    'minutaData.txtsetcat': 'calculaTotal'


  },

  created() {

  },

  mounted() {
    console.log('mounted_movcte_fiscal_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    this.carregarDados()
  },

  methods: {

    imprimir(){
      console.log('imprimir')
      this.updating = true
      api.get(`${getBaseUrl()}api/minuprint`, {
        responseType: 'blob',
        params: {iddata: this.minutaData.id}
      }).then(res => {
        console.log('res.bases')
        console.log(res.data)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `minuta_${this.idData}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },


    emitirCte(){
      console.log('emitirCte')
      this.updating = true
      api.post(`${getBaseUrl()}api/minemitcte`, {
        iddata: this.minutaData.id
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        if (res.data[0].id) {
          this.updating = false
          const routeData = this.$router.resolve(`/movctefiscal/editar/${res.data[0].id}`)
          window.open(routeData.href, '_blank')
        }
      })
    },

    abrirEmpresas(){
      console.log('abrirEmpresas')
      const routeData = this.$router.resolve(`/empresas/list`)
      window.open(routeData.href, '_blank')
    },

    onActionBeginPessoa(args) {
      if (args.requestType === 'searching') {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: args.searchString}
        }).then(response => {
          console.log('response.bases')
          console.log(response.data)
          this.pessoasData = response.data
        })
      }
    },

    onActionBeginFormPgto(args) {
      if (args.requestType === 'searching') {
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: {q: args.searchString}
        }).then(response => {
          console.log('response.bases')
          console.log(response.data)
          this.formaPgtosData = response.data
        })
      }
    },

    onActionBeginEmpresa(args) {
      if (args.requestType === 'searching') {
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: {q: args.searchString}
        }).then(response => {
          console.log('response.bases')
          console.log(response.data)
          this.empresasData = response.data
        })
      }
    },

    onActionBeginCidade(args) {
      if (args.requestType === 'searching') {
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: {q: args.searchString}
        }).then(response => {
          console.log('response.bases')
          console.log(response.data)
          this.cidadesData = response.data
        })
      }
    },

    pesquisarPessoa(origem){
      console.log('pesquisarPessoa')
      this.origemPessoasPesq = origem
      this.showModalPesqPessoa = true
      api.get(`${getBaseUrl()}api/clipesq`).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.pessoasData = response.data
      })
    },

    pesquisarCidade(origem){
      console.log('pesquisarCidade')
      this.origemCidadesPesq = origem
      this.showModalPesqCidade = true
      api.get(`${getBaseUrl()}api/cidpesq`).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.cidadesData = response.data
      })
    },

    pesquisarFormaPgto(){
      console.log('pesquisarFormaPgto')
      this.showModalPesqFormaPgto = true
      api.get(`${getBaseUrl()}api/fpgtopesq`).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.formaPgtosData = response.data
      })
    },

    pesquisarEmpresa(){
      console.log('pesquisarEmpresa')
      this.showModalPesqEmpresa = true
      api.get(`${getBaseUrl()}api/emprepesq`).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.empresasData = response.data
      })
    },

    criarPessoa(){
      console.log('criarPessoa')
      const routeData = this.$router.resolve(`/cliente/editar/0`)
      window.open(routeData.href, '_blank')
    },

    criarFormaPgto(){
      console.log('criarFormaPgto')
      const routeData = this.$router.resolve(`/formas/list`)
      window.open(routeData.href, '_blank')
    },

    calculaTotal(){
      console.log('calculaTotal')
      this.minutaData.totalfrete = (parseFloat(this.minutaData.txcoleta) || 0) + (parseFloat(this.minutaData.txentrega) || 0) +
          (parseFloat(this.minutaData.txpedagio) || 0) + (parseFloat(this.minutaData.txtad) || 0) + (parseFloat(this.minutaData.txgris) || 0) +
          (parseFloat(this.minutaData.txpesoadic) || 0) + (parseFloat(this.minutaData.txdespacho) || 0) + (parseFloat(this.minutaData.txredesp) || 0) +
          (parseFloat(this.minutaData.txoutras) || 0) + (parseFloat(this.minutaData.txtas) || 0) + (parseFloat(this.minutaData.txtrt) || 0) +
          (parseFloat(this.minutaData.txtde) || 0) + (parseFloat(this.minutaData.txtsetcat) || 0)
      if (this.minutaData.aliquota > 0) {
        this.minutaData.vlr_imposto = this.minutaData.totalfrete * this.minutaData.aliquota / 100
      }
    },

    consultarChaveDoc(){
      console.log('consultarChaveDoc')
      // console.log(this.minutaDocData.chave)
      const chaveTratada = this.minutaDocData.chave.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (chaveTratada.length !== 44){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo Chave deve possuir 44 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        // console.log(chaveTratada)
        // console.log(chaveTratada.length)
        this.loadingChaveDoc = true
        api.get(`${getBaseUrl()}api/consnotaelk`, {
          params: { chave: chaveTratada }
        }).then((res) => {
          // console.log('then axios')
          // console.log(res.data)
          if (res.data[0] === 'error') {
            console.log('erro')
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Nenhum documento encontrado.",
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            this.minutaDocData.numero = res.data[0].numero
            this.minutaDocData.serie = res.data[0].serie
            this.minutaDocData.valor = res.data[0].valor
            this.minutaDocData.valorprod = res.data[0].valor_produtos
            this.minutaDocData.natureza = res.data[0].natureza
            this.minutaDocData.datadoc = moment(res.data[0].emissao).format('YYYY-MM-DD')
            this.minutaDocData.volumes = res.data[0].volumes
            this.minutaDocData.pesoreal = res.data[0].peso_bruto
          }
          this.loadingChaveDoc = false
        });
      }
    },

    abrirCotacao(){
      console.log('abrirCotacao')
      this.$router.push(`/cotafrt/editar/${this.minutaData.cotafrt_id}`)
    },

    dataBoundCotacoes: function() {
      this.$refs.dataGridCotacoes.autoFitColumns([])
    },

    dataBoundPessoas: function() {
      this.$refs.dataGridPessoas.autoFitColumns([])
    },

    dataBoundCidades: function() {
      this.$refs.dataGridCidades.autoFitColumns([])
    },

    dataBoundFormPgtos: function() {
      this.$refs.dataGridFormaPgto.autoFitColumns([])
    },

    dataBoundEmpresas: function() {
      this.$refs.dataGridEmpresa.autoFitColumns([])
    },

    recDblClickCotacao(evt){
      console.log('recDblClickCotacao')
      console.log(evt.rowData);
      this.showModalPesqCotacao = false
      this.updating = true
      api.get(`${getBaseUrl()}api/cotafrt`, {
        params: {iddata: evt.rowData.id}
      }).then((res) => {
        console.log('then axios cotafrt')
        console.log(res.data)
        this.minutaData.cotafrt_id = evt.rowData.id
        this.minutaData.destcnpj = evt.rowData.cnpj
        if (evt.rowData.cnpj.length > 11) {
          this.minutaData.destipo = 'PJ'
        } else {
          this.minutaData.destipo = 'PF'
        }
        this.minutaData.destnome = evt.rowData.nome
        this.minutaData.destender = evt.rowData.logrdest
        this.minutaData.destnum = evt.rowData.nrodest
        this.minutaData.destcompl = evt.rowData.compldest
        this.minutaData.destcidade = evt.rowData.ciddest
        this.minutaData.destestado = evt.rowData.ufdest
        this.minutaData.volumes = evt.rowData.qtdvol
        this.minutaData.pesoreal = evt.rowData.peso
        this.minutaData.cubagem = evt.rowData.dimens

        if (res.data[8]) {
          const cotacaoDataSelected = res.data[8]
          if (cotacaoDataSelected){
            console.log('cotacaoDataSelected')
            console.log(cotacaoDataSelected)
            this.minutaData.txcoleta = cotacaoDataSelected[0].coletavlrfixo + cotacaoDataSelected[0].coletavlrkg
            this.minutaData.txentrega = cotacaoDataSelected[0].entregavlrfixo + cotacaoDataSelected[0].entregavlrkg
            this.minutaData.txpedagio = cotacaoDataSelected[0].pedagiovlrfixo + cotacaoDataSelected[0].pedagiovlrkg
            this.minutaData.txtad = cotacaoDataSelected[0].valortdafixo + cotacaoDataSelected[0].valortda
            this.minutaData.txgris = cotacaoDataSelected[0].gris
            this.minutaData.txpesoadic = cotacaoDataSelected[0].fretepesoext
            this.minutaData.txdespacho = cotacaoDataSelected[0].despachovlrfixo
            this.minutaData.txtrt = cotacaoDataSelected[0].valortrt + cotacaoDataSelected[0].valortrtfixo
            this.minutaData.txtde = cotacaoDataSelected[0].valortde + cotacaoDataSelected[0].valortdefixo
            this.minutaData.percnf = cotacaoDataSelected[0].frtcomppercnota
            this.minutaData.fretepeso = cotacaoDataSelected[0].fretepeso
          }
        }
        this.updating = false
      })
    },

    recDblClickPessoa(evt){
      console.log('recDblClickPessoa')
      console.log(evt.rowData);
      if (this.origemPessoasPesq === 'respseg') {
        this.minutaData.respseg = evt.rowData.nome
      } else if (this.origemPessoasPesq === 'seguradora') {
        this.minutaData.seguradora = evt.rowData.nome
      } else if (this.origemPessoasPesq === 'respcol') {
        this.minutaData.respcol = evt.rowData.nome
      } else if (this.origemPessoasPesq === 'respdesp') {
        this.minutaData.respdesp = evt.rowData.nome
      } else if (this.origemPessoasPesq === 'respentr') {
        this.minutaData.respentr = evt.rowData.nome
      }
      this.showModalPesqPessoa = false
    },

    recDblClickCidade(evt){
      console.log('recDblClickCidade')
      console.log(evt.rowData);
      if (this.origemCidadesPesq === 'origem') {
        this.minutaData.trcalccid = evt.rowData.descricao
      } else if (this.origemCidadesPesq === 'destino') {
        this.minutaData.trcalcciddest = evt.rowData.descricao
      }
      this.showModalPesqCidade = false
    },

    recDblClickFormaPgto(evt){
      console.log('recDblClickFormaPgto')
      console.log(evt.rowData);
      this.minutaData.formapgto = evt.rowData.descricao
      this.showModalPesqFormaPgto = false
    },

    recDblClickEmpresa(evt){
      console.log('recDblClickEmpresa')
      console.log(evt.rowData);
      this.minutaData.base = evt.rowData.nome.substring(0, 20)
      this.showModalPesqEmpresa = false
    },

    consultarCotacao() {
      console.log('consultarCotacao')
      this.showModalPesqCotacao = true
      api.get(`${getBaseUrl()}api/pesqcotacao`).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.cotacoesData = response.data
      })
    },


    onTipoItemChange(event) {
      console.log('onTipoItemChange');
      const textoCompleto = event.target.options[event.target.selectedIndex].text;
      console.log('Texto completo:', textoCompleto);
      const regex = /^(.+?)\s*-\s*R\$\s*([\d.,]+)$/;
      const match = textoCompleto.match(regex);
      if (match) {
        const texto = match[1].trim();
        const valorString = match[2].replace('.', '').replace(',', '.');
        const valorDecimal = parseFloat(valorString);
        console.log('Texto:', texto);
        console.log('Valor:', valorDecimal);
        this.minutaItemData.quant = 1;
        this.minutaItemData.descricao = texto;
        this.minutaItemData.valorun = valorDecimal;
        this.minutaItemData.valortot = valorDecimal;
      }
    },


    exclMinutaDoc(idData){
      console.log('exclMinutaDoc')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Documento de Minuta",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/minutadoc`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso.",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    confMinutaDoc(){
      console.log('confMinutaDoc')
      this.submittedMinutaDoc = true
      if (this.minutaDocData.tipo){
        this.showModalMinutaDoc = false
        this.updating = true
        api.post(`${getBaseUrl()}api/minutadoc`, {
          minutaDocData: this.minutaDocData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    exclMinutaItem(idData){
      console.log('exclMinutaItem')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Item de Minuta",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/minutaitem`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso.",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    confMinutaItem(){
      console.log('confMinutaItem')
      this.submittedMinutaItem = true
      if (this.minutaItemData.descricao && this.minutaItemData.quant && this.minutaItemData.valorun && this.minutaItemData.valortot){
        this.showModalMinutaItem = false
        this.updating = true
        api.post(`${getBaseUrl()}api/minutaitem`, {
          minutaItemData: this.minutaItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    exclMinutaLacre(idData){
      console.log('exclMinutaLacre')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Lacre de Minuta",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/minutalacre`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso.",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    exclMinutaMemo(idData){
      console.log('exclMinutaMemo')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Memo de Minuta",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/minutamemo`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso.",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    confMinutaLacre(){
      console.log('confMinutaLacre')
      this.submittedMinutaLacre = true
      if (this.minutaLacreData.lacre){
        this.showModalMinutaLacre = false
        this.updating = true
        api.post(`${getBaseUrl()}api/minutalacre`, {
          minutaLacreData: this.minutaLacreData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    confMinutaMemo(){
      console.log('confMinutaMemo')
      this.submittedMinutaMemo = true
      if (this.minutaMemoData.descricao){
        this.showModalMinutaMemo = false
        this.updating = true
        api.post(`${getBaseUrl()}api/minutamemo`, {
          minutaMemoData: this.minutaMemoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    incluiMinutaDoc(){
      console.log('incluiMinutaDoc')
      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a minuta antes de incluir documentos",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.minutaDocData = {
          'minuta_id': this.idData,
        }
        this.submittedMinutaDoc = false
        this.showModalMinutaDoc = true
      }
    },

    editarMinutaDoc(data){
      this.minutaDocData = data
      this.submittedMinutaDoc = false
      this.showModalMinutaDoc = true
    },

    incluiMinutaItem(){
      console.log('incluiMinutaItem')
      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a minuta antes de incluir itens",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.minutaItemData = {
          'minuta_id': this.idData,
        }
        this.submittedMinutaItem = false
        this.showModalMinutaItem = true
      }
    },

    editarMinutaItem(data){
      this.minutaItemData = data
      this.submittedMinutaItem = false
      this.showModalMinutaItem = true
    },


    incluiMinutaLacre(){
      console.log('incluiMinutaLacre')
      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a minuta antes de incluir lacres",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.minutaLacreData = {
          'minuta_id': this.idData,
        }
        this.submittedMinutaLacre = false
        this.showModalMinutaLacre = true
      }
    },

    editarMinutaLacre(data){
      this.minutaLacreData = data
      this.submittedMinutaLacre = false
      this.showModalMinutaLacre = true
    },

    incluiMinutaMemo(){
      console.log('incluiMinutaMemo')
      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a minuta antes de incluir memos",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.minutaMemoData = {
          'minuta_id': this.idData,
        }
        this.submittedMinutaMemo = false
        this.showModalMinutaMemo = true
      }
    },

    editarMinutaMemo(data){
      this.minutaMemoData = data
      this.submittedMinutaMemo = false
      this.showModalMinutaMemo = true
    },


    consultarRemetCNPJ(){
      console.log('consultarRemetCNPJ')
      const cnpjTratado = this.minutaData.remetcnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingRemet = true
        api.get(`${getBaseUrl()}api/conscnpjelk`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.minutaData.remetnome = res.data[0].nome
          this.minutaData.remetender = res.data[0].endereco
          this.minutaData.remetnum = res.data[0].numero
          this.minutaData.remetcompl = res.data[0].complemento
          this.minutaData.remetcidade = res.data[0].cidade
          this.minutaData.remetestado = res.data[0].estado
          this.loadingRemet = false
        });
      }
    },


    consultarCliCNPJ(){
      console.log('consultarCliCNPJ')
      const cnpjTratado = this.minutaData.clicnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingCliente = true
        api.get(`${getBaseUrl()}api/conscnpjelk`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.minutaData.clinome = res.data[0].nome
          this.loadingCliente = false
        });
      }
    },


    consultarExpedCNPJ(){
      console.log('consultarExpedCNPJ')
      const cnpjTratado = this.minutaData.expedcnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingExped = true
        api.get(`${getBaseUrl()}api/conscnpjelk`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.minutaData.expednome = res.data[0].nome
          this.minutaData.expedender = res.data[0].endereco
          this.minutaData.expednum = res.data[0].numero
          this.minutaData.expedcompl = res.data[0].complemento
          this.minutaData.expedcidade = res.data[0].cidade
          this.minutaData.expedestado = res.data[0].estado
          this.loadingExped = false
        });
      }
    },

    consultarEntrCNPJ(){
      console.log('consultarEntrCNPJ')
      const cnpjTratado = this.minutaData.entrcnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingEntr = true
        api.get(`${getBaseUrl()}api/conscnpjelk`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.minutaData.entrnome = res.data[0].nome
          this.minutaData.entrender = res.data[0].endereco
          this.minutaData.entrnum = res.data[0].numero
          this.minutaData.entrcompl = res.data[0].complemento
          this.minutaData.entrcidade = res.data[0].cidade
          this.minutaData.entrestado = res.data[0].estado
          this.loadingEntr = false
        });
      }
    },

    consultarDestCNPJ(){
      console.log('consultarDestCNPJ')
      const cnpjTratado = this.minutaData.destcnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.loadingDest = true
        api.get(`${getBaseUrl()}api/conscnpjelk`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.minutaData.destnome = res.data[0].nome
          this.minutaData.destender = res.data[0].endereco
          this.minutaData.destnum = res.data[0].numero
          this.minutaData.destcompl = res.data[0].complemento
          this.minutaData.destcidade = res.data[0].cidade
          this.minutaData.destestado = res.data[0].estado
          this.loadingDest = false
        });
      }
    },

    carregarDados(){
      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/minuta`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.minutaData = res.data[0]
            this.minutaDocsData = res.data[1]
            this.minutaItensData = res.data[2]
            this.minutaLacresData = res.data[3]
            this.minutaMemosData = res.data[4]

            this.title = `Editando Minuta ${this.minutaData.id}`
            this.updating = false
          }
        });
      }else{
        this.title = `Criando Nova Minuta`
        this.updating = false
      }

      api.get(`${getBaseUrl()}api/minutadefs`).then((res) => {
        console.log('response_defaults')
        console.log(res.data)
        this.minutaDefServs = res.data[0]
        this.minutaDefItensAdics = res.data[1]
        this.minutaDefTrechos = res.data[2]
        this.minutaDefVeics = res.data[3]
      })

    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      if (this.minutaData.tipoemis) {
        this.updating = true
        api.post(`${getBaseUrl()}api/minuta`, {
          minutaData: this.minutaData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0){
            this.idData = res.data[0].id
            this.minutaData = res.data[0]
            this.$router.replace('/minuta/editar/' + this.idData)
            this.title = `Editando Minuta ${this.minutaData.id}`
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit" :disabled="updating">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="imprimir">
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="emitirCte">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Emitir CT-e
              </b-button>

            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div v-if="!updating">
      <form class="needs-validation" @submit.prevent="formSubmit">

        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">Informações Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="coleta">Coleta</label>
                      <input id="coleta"
                             v-model="minutaData.coleta_id"
                             type="number"
                             class="form-control"
                             placeholder="Coleta"/>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="emissao">Emissão</label>
                      <input id="emissao"
                             v-model="minutaData.emissao"
                             type="datetime-local"
                             class="form-control"
                             placeholder="Emissão"/>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="cotacao">Cotação</label>
                    <div class="position-relative">
                      <input id="cotacao"
                             type="text" v-model="minutaData.cotafrt_id" disabled class="form-control"
                             placeholder="Cotação" />
                      <div class="chat-input-links">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a v-if="minutaData.cotafrt_id"
                               @click="abrirCotacao"
                               href="javascript: void(0);" v-b-tooltip.hover placement="top"
                               title="Abrir Cotação">
                              <i class="mdi mdi-book-open-outline"></i>
                            </a>
                            <a @click="consultarCotacao"
                               href="javascript: void(0);" v-b-tooltip.hover placement="top"
                               title="Consultar Cotação">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>




                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="house">House</label>
                      <input id="house"
                             v-model="minutaData.house"
                             type="text"
                             class="form-control"
                             placeholder="House"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="base">Base Emissora</label>
                    <div class="position-relative">
                      <input id="base"
                             type="text" v-model="minutaData.base" disabled class="form-control"
                             placeholder="Base Emissora" />
                      <div class="chat-input-links">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a @click="pesquisarEmpresa"
                               href="javascript: void(0);" v-b-tooltip.hover placement="top"
                               title="Consultar Bases">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>



                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="tipoemis">Tipo Emissão</label>
                      <select id="tipoemis" v-model="minutaData.tipoemis" class="form-control">
                        <option value="ENT">Entrega</option>
                        <option value="DEV">Devolução</option>
                        <option value="RET">Reentrega</option>
                      </select>
                    </div>
                  </div>

                </div>

              </b-card-body>
            </b-collapse>


            <div class="row">
              <div class="card col-md-6">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-2 class="text-dark" href="javascript: void(0);">Remetente</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                  <b-card-body>
                    <div class="row mb-2">

                      <div class="col-md-4">
                        <label for="remetcnpj" v-if="minutaData.remetipo === 'PJ'">CNPJ</label>
                        <label for="remetcnpj" v-else>CPF</label>
                        <div class="position-relative">
                          <input v-if="minutaData.remetipo === 'PJ'" id="remetcnpj" v-maska="'##.###.###/####-##'"
                                 type="text" v-model="minutaData.remetcnpj" class="form-control" placeholder="CNPJ"
                                 :class="{'is-invalid': submitted && !minutaData.remetcnpj}" />
                          <input v-else id="remetcnpj" v-maska="'###.###.###-##'"
                                 type="text" v-model="minutaData.remetcnpj" class="form-control" placeholder="CPF"
                                 :class="{'is-invalid': submitted && !minutaData.remetcnpj}" />
                          <div v-if="submitted && !minutaData.remetcnpj" class="invalid-feedback">
                            <span>Campo CNPJ obrigatório, favor preencher.</span>
                          </div>
                          <div class="chat-input-links" v-if="minutaData.remetcnpj && minutaData.remetipo === 'PJ'">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a @click="consultarRemetCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                   title="Consultar CNPJ">
                                  <i class="mdi mdi-cloud-search-outline"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="tipo">Tipo</label>
                          <select id="tipo" v-model="minutaData.remetipo" class="form-control">
                            <option value="PF">Pessoa Física</option>
                            <option value="PJ">Pessoa Jurídica</option>
                          </select>
                        </div>
                      </div>

                    </div>

                    <div class="row" v-if="loadingRemet">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>

                    <div v-if="!loadingRemet">

                      <div class="row mb-2">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="remetnome">Nome</label>
                            <input id="remetnome"
                                   v-model="minutaData.remetnome"
                                   type="text"
                                   class="form-control"
                                   placeholder="Nome"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="remetender">Endereço</label>
                            <input id="remetender"
                                   v-model="minutaData.remetender"
                                   type="text"
                                   class="form-control"
                                   placeholder="Endereço"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-6">
                          <div class="mb-3">
                            <label for="remetcompl">Complemento</label>
                            <input id="remetcompl"
                                   v-model="minutaData.remetcompl"
                                   type="text"
                                   class="form-control"
                                   placeholder="Complemento"/>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="mb-3">
                            <label for="remetnum">Número</label>
                            <input id="remetnum"
                                   v-model="minutaData.remetnum"
                                   type="text"
                                   class="form-control"
                                   placeholder="Número"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-10">
                          <div class="mb-3">
                            <label for="remetcidade">Cidade</label>
                            <input id="remetcidade"
                                   v-model="minutaData.remetcidade"
                                   type="text"
                                   class="form-control"
                                   placeholder="Cidade"/>
                          </div>
                        </div>

                          <div class="col-sm-2">
                            <div class="mb-3">
                              <label for="remetestado">Estado</label>
                              <select id="remetestado" v-model="minutaData.remetestado" class="form-control">
                                <option value="AC">Acre</option>
                                <option value="AL">Alagoas</option>
                                <option value="AP">Amapá</option>
                                <option value="AM">Amazonas</option>
                                <option value="BA">Bahia</option>
                                <option value="CE">Ceará</option>
                                <option value="ES">Espírito Santo</option>
                                <option value="GO">Goiás</option>
                                <option value="MA">Maranhão</option>
                                <option value="MT">Mato Grosso</option>
                                <option value="MS">Mato Grosso do Sul</option>
                                <option value="MG">Minas Gerais</option>
                                <option value="PA">Pará</option>
                                <option value="PB">Paraíba</option>
                                <option value="PR">Paraná</option>
                                <option value="PE">Pernambuco</option>
                                <option value="PI">Piauí</option>
                                <option value="RJ">Rio de Janeiro</option>
                                <option value="RN">Rio Grande do Norte</option>
                                <option value="RS">Rio Grande do Sul</option>
                                <option value="RO">Rondônia</option>
                                <option value="RR">Roraima</option>
                                <option value="SC">Santa Catarina</option>
                                <option value="SP">São Paulo</option>
                                <option value="SE">Sergipe</option>
                                <option value="TO">Tocantins</option>
                                <option value="DF">Distrito Federal</option>
                              </select>
                            </div>
                          </div>

                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </div>

              <div class="card col-md-6">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-3 class="text-dark" href="javascript: void(0);">Destinatário</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                  <b-card-body>
                    <div class="row">

                      <div class="col-md-4">
                        <label for="destcnpj" v-if="minutaData.destipo === 'PJ'">CNPJ</label>
                        <label for="destcnpj" v-else>CPF</label>
                        <div class="position-relative">
                          <input v-if="minutaData.destipo === 'PJ'" id="destcnpj" v-maska="'##.###.###/####-##'"
                                 type="text" v-model="minutaData.destcnpj" class="form-control" placeholder="CNPJ"
                                 :class="{'is-invalid': submitted && !minutaData.destcnpj}" />
                          <input v-else id="destcnpj" v-maska="'###.###.###-##'"
                                 type="text" v-model="minutaData.destcnpj" class="form-control" placeholder="CPF"
                                 :class="{'is-invalid': submitted && !minutaData.destcnpj}" />
                          <div v-if="submitted && !minutaData.destcnpj" class="invalid-feedback">
                            <span>Campo CNPJ obrigatório, favor preencher.</span>
                          </div>
                          <div class="chat-input-links" v-if="minutaData.destcnpj && minutaData.destipo === 'PJ'">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a @click="consultarDestCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                   title="Consultar CNPJ">
                                  <i class="mdi mdi-cloud-search-outline"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="tipo">Tipo</label>
                          <select id="tipo" v-model="minutaData.destipo" class="form-control">
                            <option value="PF">Pessoa Física</option>
                            <option value="PJ">Pessoa Jurídica</option>
                          </select>
                        </div>
                      </div>

                    </div>

                    <div class="row" v-if="loadingDest">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>

                    <div v-if="!loadingDest">

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="destnome">Nome</label>
                            <input id="destnome"
                                   v-model="minutaData.destnome"
                                   type="text"
                                   class="form-control"
                                   placeholder="Nome"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="destender">Endereço</label>
                            <input id="destender"
                                   v-model="minutaData.destender"
                                   type="text"
                                   class="form-control"
                                   placeholder="Endereço"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-6">
                          <div class="mb-3">
                            <label for="destcompl">Complemento</label>
                            <input id="destcompl"
                                   v-model="minutaData.destcompl"
                                   type="text"
                                   class="form-control"
                                   placeholder="Complemento"/>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="mb-3">
                            <label for="destnum">Número</label>
                            <input id="destnum"
                                   v-model="minutaData.destnum"
                                   type="text"
                                   class="form-control"
                                   placeholder="Número"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-10">
                          <div class="mb-3">
                            <label for="destcidade">Cidade</label>
                            <input id="destcidade"
                                   v-model="minutaData.destcidade"
                                   type="text"
                                   class="form-control"
                                   placeholder="Cidade"/>
                          </div>
                        </div>

                        <div class="col-sm-2">
                          <div class="mb-3">
                            <label for="destestado">Estado</label>
                            <select id="destestado" v-model="minutaData.destestado" class="form-control">
                              <option value="AC">Acre</option>
                              <option value="AL">Alagoas</option>
                              <option value="AP">Amapá</option>
                              <option value="AM">Amazonas</option>
                              <option value="BA">Bahia</option>
                              <option value="CE">Ceará</option>
                              <option value="ES">Espírito Santo</option>
                              <option value="GO">Goiás</option>
                              <option value="MA">Maranhão</option>
                              <option value="MT">Mato Grosso</option>
                              <option value="MS">Mato Grosso do Sul</option>
                              <option value="MG">Minas Gerais</option>
                              <option value="PA">Pará</option>
                              <option value="PB">Paraíba</option>
                              <option value="PR">Paraná</option>
                              <option value="PE">Pernambuco</option>
                              <option value="PI">Piauí</option>
                              <option value="RJ">Rio de Janeiro</option>
                              <option value="RN">Rio Grande do Norte</option>
                              <option value="RS">Rio Grande do Sul</option>
                              <option value="RO">Rondônia</option>
                              <option value="RR">Roraima</option>
                              <option value="SC">Santa Catarina</option>
                              <option value="SP">São Paulo</option>
                              <option value="SE">Sergipe</option>
                              <option value="TO">Tocantins</option>
                              <option value="DF">Distrito Federal</option>
                            </select>
                          </div>
                        </div>

                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </div>

            </div>


            <div class="row">
              <div class="card col-md-6">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-4 class="text-dark" href="javascript: void(0);">Expedidor</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                  <b-card-body>
                    <div class="row">

                      <div class="col-md-4">
                        <label for="expedcnpj" v-if="minutaData.expedtipo === 'PJ'">CNPJ</label>
                        <label for="expedcnpj" v-else>CPF</label>
                        <div class="position-relative">
                          <input v-if="minutaData.expedtipo === 'PJ'" id="expedcnpj" v-maska="'##.###.###/####-##'"
                                 type="text" v-model="minutaData.expedcnpj" class="form-control" placeholder="CNPJ" />
                          <input v-else id="expedcnpj" v-maska="'###.###.###-##'"
                                 type="text" v-model="minutaData.expedcnpj" class="form-control" placeholder="CPF"/>
                          <div class="chat-input-links" v-if="minutaData.expedcnpj && minutaData.expedtipo === 'PJ'">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a @click="consultarExpedCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                   title="Consultar CNPJ">
                                  <i class="mdi mdi-cloud-search-outline"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="tipo">Tipo</label>
                          <select id="tipo" v-model="minutaData.expedtipo" class="form-control">
                            <option value="PF">Pessoa Física</option>
                            <option value="PJ">Pessoa Jurídica</option>
                          </select>
                        </div>
                      </div>


                    </div>

                    <div class="row" v-if="loadingExped">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>

                    <div v-if="!loadingExped">

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="expednome">Nome</label>
                            <input id="expednome"
                                   v-model="minutaData.expednome"
                                   type="text"
                                   class="form-control"
                                   placeholder="Nome"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-10">
                          <div class="mb-3">
                            <label for="expedcidade">Cidade</label>
                            <input id="expedcidade"
                                   v-model="minutaData.expedcidade"
                                   type="text"
                                   class="form-control"
                                   placeholder="Cidade"/>
                          </div>
                        </div>

                        <div class="col-sm-2">
                          <div class="mb-3">
                            <label for="expedestado">Estado</label>
                            <select id="expedestado" v-model="minutaData.expedestado" class="form-control">
                              <option value="AC">Acre</option>
                              <option value="AL">Alagoas</option>
                              <option value="AP">Amapá</option>
                              <option value="AM">Amazonas</option>
                              <option value="BA">Bahia</option>
                              <option value="CE">Ceará</option>
                              <option value="ES">Espírito Santo</option>
                              <option value="GO">Goiás</option>
                              <option value="MA">Maranhão</option>
                              <option value="MT">Mato Grosso</option>
                              <option value="MS">Mato Grosso do Sul</option>
                              <option value="MG">Minas Gerais</option>
                              <option value="PA">Pará</option>
                              <option value="PB">Paraíba</option>
                              <option value="PR">Paraná</option>
                              <option value="PE">Pernambuco</option>
                              <option value="PI">Piauí</option>
                              <option value="RJ">Rio de Janeiro</option>
                              <option value="RN">Rio Grande do Norte</option>
                              <option value="RS">Rio Grande do Sul</option>
                              <option value="RO">Rondônia</option>
                              <option value="RR">Roraima</option>
                              <option value="SC">Santa Catarina</option>
                              <option value="SP">São Paulo</option>
                              <option value="SE">Sergipe</option>
                              <option value="TO">Tocantins</option>
                              <option value="DF">Distrito Federal</option>
                            </select>
                          </div>
                        </div>


                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </div>

              <div class="card col-md-6">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-5 class="text-dark" href="javascript: void(0);">Local de Entrega</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
                  <b-card-body>
                    <div class="row">

                      <div class="col-md-4">
                        <label for="entrcnpj" v-if="minutaData.entrtipo === 'PJ'">CNPJ</label>
                        <label for="entrcnpj" v-else>CPF</label>
                        <div class="position-relative">
                          <input v-if="minutaData.entrtipo === 'PJ'" id="entrcnpj" v-maska="'##.###.###/####-##'"
                                 type="text" v-model="minutaData.entrcnpj" class="form-control" placeholder="CNPJ"/>
                          <input v-else id="entrcnpj" v-maska="'###.###.###-##'"
                                 type="text" v-model="minutaData.entrcnpj" class="form-control" placeholder="CPF"/>
                          <div class="chat-input-links" v-if="minutaData.entrcnpj && minutaData.entrtipo === 'PJ'">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a @click="consultarEntrCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                   title="Consultar CNPJ">
                                  <i class="mdi mdi-cloud-search-outline"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="tipo">Tipo</label>
                          <select id="tipo" v-model="minutaData.entrtipo" class="form-control">
                            <option value="PF">Pessoa Física</option>
                            <option value="PJ">Pessoa Jurídica</option>
                          </select>
                        </div>
                      </div>

                    </div>


                    <div class="row" v-if="loadingEntr">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>

                    <div v-if="!loadingEntr">

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mb-3">
                            <label for="entrnome">Nome</label>
                            <input id="entrnome"
                                   v-model="minutaData.entrnome"
                                   type="text"
                                   class="form-control"
                                   placeholder="Nome"/>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-10">
                          <div class="mb-3">
                            <label for="entrcidade">Cidade</label>
                            <input id="entrcidade"
                                   v-model="minutaData.entrcidade"
                                   type="text"
                                   class="form-control"
                                   placeholder="Cidade"/>
                          </div>
                        </div>

                        <div class="col-sm-2">
                          <div class="mb-3">
                            <label for="entrestado">Estado</label>
                            <select id="entrestado" v-model="minutaData.entrestado" class="form-control">
                              <option value="AC">Acre</option>
                              <option value="AL">Alagoas</option>
                              <option value="AP">Amapá</option>
                              <option value="AM">Amazonas</option>
                              <option value="BA">Bahia</option>
                              <option value="CE">Ceará</option>
                              <option value="ES">Espírito Santo</option>
                              <option value="GO">Goiás</option>
                              <option value="MA">Maranhão</option>
                              <option value="MT">Mato Grosso</option>
                              <option value="MS">Mato Grosso do Sul</option>
                              <option value="MG">Minas Gerais</option>
                              <option value="PA">Pará</option>
                              <option value="PB">Paraíba</option>
                              <option value="PR">Paraná</option>
                              <option value="PE">Pernambuco</option>
                              <option value="PI">Piauí</option>
                              <option value="RJ">Rio de Janeiro</option>
                              <option value="RN">Rio Grande do Norte</option>
                              <option value="RS">Rio Grande do Sul</option>
                              <option value="RO">Rondônia</option>
                              <option value="RR">Roraima</option>
                              <option value="SC">Santa Catarina</option>
                              <option value="SP">São Paulo</option>
                              <option value="SE">Sergipe</option>
                              <option value="TO">Tocantins</option>
                              <option value="DF">Distrito Federal</option>
                            </select>
                          </div>
                        </div>

                      </div>

                    </div>
                  </b-card-body>
                </b-collapse>
              </div>

            </div>
          </div>
        </div>


        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a v-b-toggle.accordion-6 class="text-dark" href="javascript: void(0);">Notas Fiscais / Declarações relacionadas a esta emissão</a>
            <b-dropdown class="btn-group mx-2 float-end" variant="outline-info">
              <template v-slot:button-content>
                <i class="fa fa-plus-circle me-2"></i>
                Novo Documento
                <i class="mdi mdi-chevron-down ms-4"></i>
              </template>
              <a class="dropdown-item" href="javascript: void(0);" @click="incluiMinutaDoc">Chave NF-e</a>
              <a class="dropdown-item" href="javascript: void(0);" @click="incluiMinutaDoc">Chave CT-e</a>
              <a class="dropdown-item" href="javascript: void(0);" @click="incluiMinutaDoc">Manual</a>
              <a class="dropdown-item" href="javascript: void(0);" @click="incluiMinutaDoc">Arquivo XML NF-e</a>
              <a class="dropdown-item" href="javascript: void(0);" @click="incluiMinutaDoc">Arquivo XML CT-e</a>
            </b-dropdown>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
          <b-card-body>
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th scope="col">Tipo</th>
                  <th scope="col">Chave</th>
                  <th scope="col" class="text-end">Número</th>
                  <th scope="col" class="text-end">Série</th>
                  <th scope="col" class="text-end">Valor NF</th>
                  <th scope="col" class="text-end">Valor Produtos</th>
                  <th scope="col">Data</th>
                  <th scope="col" class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in minutaDocsData" :key="data.id">
                  <td>
                    <h5 class="font-size-12">
                        <span class="text-black-50">
                          {{ data.tipo }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12">
                        <span class="text-black-50">
                          {{ data.chave }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12 text-end">
                        <span class="text-black-50">
                          {{ data.numero }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12 text-end">
                        <span class="text-black-50">
                          {{ data.serie }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12 text-black-50 text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.valor) }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12 text-black-50 text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.valorprod) }}
                        </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-12 text-black-50">
                        <span class="text-black-50">
                          {{ data.datadoc !== null ? formatDate(data.datadoc) : '' }}
                        </span>
                    </h5>
                  </td>

                  <td class="text-end">
                    <div class="button-items">
                      <b-button variant="outline-warning" @click="editarMinutaDoc(data)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="exclMinutaDoc(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </b-card-body>
        </b-collapse>


        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a v-b-toggle.accordion-7 class="text-dark" href="javascript: void(0);">Transportado</a>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
          <b-card-body>

            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="servico">Serviço - Operação</label>
                  <select id="servico" v-model="minutaData.servico" class="form-control">
                    <option :value="data.codigo" v-for="data in minutaDefServs" :key="data.id">{{ data.descricao }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="volumes">Volumes</label>
                  <input id="volumes"
                         v-model="minutaData.volumes"
                         type="number"
                         class="form-control text-end"
                         placeholder="Volumes"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="peso_real">Peso Real</label>
                  <input id="peso_real"
                         v-model="minutaData.peso_real"
                         type="number"
                         class="form-control text-end"
                         placeholder="Peso Real"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="cubagem">Cubagem</label>
                  <input id="cubagem"
                         v-model="minutaData.cubagem"
                         type="number"
                         class="form-control text-end"
                         placeholder="Cubagem"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="totaltax">Total Taxado</label>
                  <input id="totaltax"
                         v-model="minutaData.totaltax"
                         type="number"
                         class="form-control text-end"
                         placeholder="Total Taxado"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlr_notas">Valor das Notas</label>
                  <input id="vlr_notas"
                         v-model="minutaData.vlr_notas"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor das Notas"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlr_prods">Valor dos Produtos</label>
                  <input id="vlr_prods"
                         v-model="minutaData.vlr_prods"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor dos Produtos"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlrtottransp">Valor Total Transportado</label>
                  <input id="vlrtottransp"
                         v-model="minutaData.vlrtottransp"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor Total Transportado"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlrunit">Valor Unitário</label>
                  <input id="vlrunit"
                         v-model="minutaData.vlrunit"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor Unitário"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="mcubic">Metragem Cúbica</label>
                  <input id="mcubic"
                         v-model="minutaData.mcubic"
                         type="number"
                         class="form-control text-end"
                         placeholder="Metragem Cúbica"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="contrtemp">Possui Controle Temperatura</label>
                  <select id="contrtemp" v-model="minutaData.contrtemp" class="form-control">
                    <option value="SIM">Sim</option>
                    <option value="NAO">Não</option>
                    <option value="NAP">Não aplicável</option>
                  </select>
                </div>
              </div>

            </div>


            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="ctesubcont">CT-e Subcontratado</label>
                  <input id="ctesubcont"
                         v-model="minutaData.ctesubcont"
                         type="text"
                         class="form-control"
                         placeholder="CT-e Subcontratado"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlrsubconcte">Valor Sub CT-e</label>
                  <input id="vlrsubconcte"
                         v-model="minutaData.vlrsubconcte"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor Sub CT-e"/>
                </div>
              </div>

            </div>

            <div class="row mb-2">

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="autfrete">Autorização Frete</label>
                  <input id="autfrete"
                         v-model="minutaData.autfrete"
                         type="text"
                         class="form-control"
                         placeholder="Autorização Frete"/>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="ordserv">Ordem de Serviço</label>
                  <input id="ordserv"
                         v-model="minutaData.ordserv"
                         type="text"
                         class="form-control"
                         placeholder="Ordem de Serviço"/>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="mensalert">Mensagem de Alerta</label>
                  <input id="mensalert"
                         v-model="minutaData.mensalert"
                         type="text"
                         class="form-control"
                         placeholder="Mensagem de Alerta"/>
                </div>
              </div>

            </div>


            <div class="row mb-2">

              <div class="col-md-4">
                <label for="respseg">Responsável pelo Seguro</label>
                <div class="position-relative">
                  <input id="respseg"
                         type="text" v-model="minutaData.respseg"
                         class="form-control"
                         placeholder="Responsável pelo Seguro" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarPessoa" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Criar Novo">
                          <i class="mdi mdi-plus-circle-outline"></i>
                        </a>
                        <a @click="pesquisarPessoa('respseg')" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <label for="seguradora">Seguradora</label>
                <div class="position-relative">
                  <input id="seguradora"
                         type="text" v-model="minutaData.seguradora"
                         class="form-control"
                         placeholder="Seguradora" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarPessoa" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Criar Novo">
                          <i class="mdi mdi-plus-circle-outline"></i>
                        </a>
                        <a @click="pesquisarPessoa('seguradora')" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlrseg">Valor Segurado</label>
                  <input id="vlrseg"
                         v-model="minutaData.vlrseg"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor Segurado"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlrimpsus">Valor Imposto Suspenso</label>
                  <input id="vlrimpsus"
                         v-model="minutaData.vlrimpsus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Valor Imposto Suspenso"/>
                </div>
              </div>

            </div>


            <div class="row mb-2 mt-4">
              <h6 class="text-black-50">Itens Adicionais
                <b-button variant="outline-info" class="mx-2 float-end" @click="incluiMinutaItem">
                  <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                  Novo Item Adicional
                </b-button>
              </h6>
              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Descrição</th>
                    <th scope="col" class="text-end">Quantidade</th>
                    <th scope="col" class="text-end">Valor Unitário</th>
                    <th scope="col" class="text-end">Valor Total</th>
                    <th scope="col" class="text-end">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in minutaItensData" :key="data.id">
                    <td>
                      <h5 class="font-size-12 text-truncate">
                        <span class="text-black-50">
                          {{ data.descricao }}
                        </span>
                      </h5>
                    </td>
                    <td>
                      <h5 class="font-size-12 text-truncate text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.quant) }}
                        </span>
                      </h5>
                    </td>
                    <td>
                      <h5 class="font-size-12 text-truncate text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.valorun) }}
                        </span>
                      </h5>
                    </td>
                    <td>
                      <h5 class="font-size-12 text-truncate text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.valortot) }}
                        </span>
                      </h5>
                    </td>

                    <td class="text-end">
                      <div class="button-items">
                        <b-button variant="outline-warning" @click="editarMinutaItem(data)">
                          <i class="mdi mdi-pencil d-block font-size-16"></i>
                        </b-button>
                        <b-button variant="outline-danger" @click="exclMinutaItem(data.id)">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row mb-2 mt-4">
              <h6 class="text-black-50">Lacres Volumes
                <b-button variant="outline-info" class="mx-2 float-end" @click="incluiMinutaLacre">
                  <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                  Novo Lacre
                </b-button>
              </h6>
              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Lacre</th>
                    <th scope="col" class="text-end">Volume</th>
                    <th scope="col" class="text-end">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in minutaLacresData" :key="data.id">
                    <td>
                      <h5 class="font-size-12 text-truncate">
                        <span class="text-black-50">
                          {{ data.lacre }}
                        </span>
                      </h5>
                    </td>
                    <td>
                      <h5 class="font-size-12 text-truncate text-end">
                        <span class="text-black-50">
                          {{ formatDecimal(data.volume) }}
                        </span>
                      </h5>
                    </td>

                    <td class="text-end">
                      <div class="button-items">
                        <b-button variant="outline-warning" @click="editarMinutaLacre(data)">
                          <i class="mdi mdi-pencil d-block font-size-16"></i>
                        </b-button>
                        <b-button variant="outline-danger" @click="exclMinutaLacre(data.id)">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </b-card-body>
        </b-collapse>


        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a v-b-toggle.accordion-8 class="text-dark" href="javascript: void(0);">Outras Informações</a>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
          <b-card-body>

            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="servico">Responsável pelo Frete / Tomador</label>
                  <select id="servico" v-model="minutaData.respfrete" class="form-control">
                    <option value="1">1 - Remetente</option>
                    <option value="2">2 - Destinatário</option>
                    <option value="3">3 - Outro / Tomador</option>
                    <option value="4">4 - Expedidor</option>
                    <option value="5">5 - Local de Entrega / Recebedor</option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <label for="clicnpj">CNPJ do Cliente</label>
                <div class="position-relative">
                  <input id="clicnpj"
                         type="text"
                         v-model="minutaData.clicnpj"
                         class="form-control"
                         placeholder="CNPJ do Cliente"/>
                  <div class="chat-input-links" v-if="minutaData.clicnpj">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="consultarCliCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Consultar CNPJ">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>



              <div class="col-sm-3">
                <div class="mb-3" v-if="loadingCliente">
                  <div class="col-12 text-center">
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                  </div>
                </div>
                <div class="mb-3" v-else>
                  <label for="clinome">Nome do Cliente</label>
                  <input id="clinome"
                         v-model="minutaData.clinome"
                         type="text"
                         class="form-control text-end"
                         placeholder="Nome do Cliente"/>
                </div>
              </div>

              <div class="col-sm-5">
                <label for="formapgto">Forma de Pagamento</label>
                <div class="position-relative">
                  <input id="formapgto"
                         type="text" v-model="minutaData.formapgto"
                         class="form-control"
                         placeholder="Forma de Pagamento" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarFormaPgto" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Abrir Cadastro de Formas de Pagamento">
                          <i class="mdi mdi-book-open-outline"></i>
                        </a>
                        <a @click="pesquisarFormaPgto" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>




              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="coletado">Coletado</label>
                  <input id="coletado"
                         v-model="minutaData.coletado"
                         type="datetime-local"
                         class="form-control"
                         placeholder="Coletado"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="prevsaida">Previsão de Saída</label>
                  <input id="prevsaida"
                         v-model="minutaData.prevsaida"
                         type="datetime-local"
                         class="form-control"
                         placeholder="Previsão de Saída"/>
                </div>
              </div>

            </div>

            <div class="row mb-4">

              <div class="col-sm-2">
                <label for="agenentr"> Agendamento Entrega </label>
                <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                  <b-form-checkbox
                      id="agenentr"
                      switch
                      size="md"
                      value="A"
                      unchecked-value="I"
                      v-model="minutaData.agenentr">
                    {{ minutaData.agenentr === 'A' ? 'Ativo' : 'Inativo' }}
                  </b-form-checkbox>
                </div>
              </div>


                <div class="col-sm-2" v-if="minutaData.agenentr === 'A'">
                  <div class="mb-3">
                    <label for="dtagenentr">Data de Agendamento</label>
                    <input id="dtagenentr"
                           v-model="minutaData.dtagenentr"
                           type="datetime-local"
                           class="form-control"
                           placeholder="Data de Agendamento"/>
                  </div>
                </div>
                <div class="col-sm-2" v-if="minutaData.agenentr === 'A'">
                  <div class="mb-3">
                    <label for="hragenentr">Horário de Agendamento</label>
                    <input id="hragenentr"
                           v-model="minutaData.hragenentr"
                           type="time"
                           class="form-control"
                           placeholder="Horário de Agendamento"/>
                  </div>
                </div>
                <div class="col-sm-2" v-if="minutaData.agenentr === 'A'">
                  <div class="mb-3">
                    <label for="lmagenentr">Até as</label>
                    <input id="lmagenentr"
                           v-model="minutaData.hragenentr"
                           type="time"
                           class="form-control"
                           placeholder="Até as"/>
                  </div>
                </div>

            </div>


            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="preventr">Previsão de Entrega</label>
                  <input id="preventr"
                         v-model="minutaData.preventr"
                         type="datetime-local"
                         class="form-control"
                         placeholder="Previsão de Entrega"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="prazo">Prazo</label>
                  <input id="prazo"
                         v-model="minutaData.prazo"
                         type="number"
                         class="form-control text-end"
                         placeholder="Prazo"/>
                </div>
              </div>

              <div class="col-md-8">
                <label for="obs">Observações</label>
                <div class="position-relative">
                        <textarea
                            id="obs"
                            type="text"
                            rows="4"
                            v-model="minutaData.obs"
                            class="form-control"
                            placeholder="Observações"/>
                </div>
              </div>

            </div>

            <h6 class="card-title mt-4">Trecho Transferência</h6>
            <hr >

            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="trechotransori">Origem</label>
                  <select id="trechotransori" v-model="minutaData.trechotransori" class="form-control">
                    <option :value="data.codigo" v-for="data in minutaDefTrechos" :key="data.id">{{ data.descricao }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="trechotransdest">Destino</label>
                  <select id="trechotransdest" v-model="minutaData.trechotransdest" class="form-control">
                    <option :value="data.codigo" v-for="data in minutaDefTrechos" :key="data.id">{{ data.descricao }}</option>
                  </select>
                </div>
              </div>

            </div>


            <div class="row mb-2 mt-4">
              <h6 class="text-black-50">Memo (interno)
                <b-button variant="outline-info" class="mx-2 float-end" @click="incluiMinutaMemo">
                  <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                  Novo Memo
                </b-button>
              </h6>
              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Descrição</th>
                    <th scope="col" class="text-end">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in minutaMemosData" :key="data.id">
                    <td>
                      <h5 class="font-size-10 text-truncate">
                        <span class="text-dark">
                          {{ data.descricao }}
                        </span>
                      </h5>
                    </td>

                    <td class="text-end">
                      <div class="button-items">
                        <b-button variant="outline-warning" @click="editarMinutaMemo(data)">
                          <i class="mdi mdi-pencil d-block font-size-16"></i>
                        </b-button>
                        <b-button variant="outline-danger" @click="exclMinutaMemo(data.id)">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>


          </b-card-body>
        </b-collapse>




        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a v-b-toggle.accordion-9 class="text-dark" href="javascript: void(0);">Custos</a>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-9" visible accordion="my-accordion-9" role="tabpanel">
          <b-card-body>

            <div class="row mb-2">

              <div class="col-sm-4">
                <label for="respcol">Responsável pela Coleta</label>
                <div class="position-relative">
                  <input id="respcol"
                         type="text" v-model="minutaData.respcol"
                         class="form-control"
                         placeholder="Responsável pela Coleta" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarPessoa" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Criar Novo">
                          <i class="mdi mdi-plus-circle-outline"></i>
                        </a>
                        <a @click="pesquisarPessoa('respcol')" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="respcolcus">Custo</label>
                  <input id="respcolcus"
                         v-model="minutaData.respcolcus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Custo"/>
                </div>
              </div>


              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="respcolvei">Veículo</label>
                  <select id="respcolvei" v-model="minutaData.respcolvei" class="form-control">
                    <option :value="data.codigo" v-for="data in minutaDefVeics" :key="data.id">{{ data.descricao }}</option>
                  </select>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="respcolveicus">Custo</label>
                  <input id="respcolveicus"
                         v-model="minutaData.respcolveicus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Custo"/>
                </div>
              </div>

              <div class="col-sm-4">
                <label for="respdesp">Responsável pelo Despacho</label>
                <div class="position-relative">
                  <input id="respdesp"
                         type="text" v-model="minutaData.respdesp"
                         class="form-control"
                         placeholder="Responsável pelo Despacho" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarPessoa" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Criar Novo">
                          <i class="mdi mdi-plus-circle-outline"></i>
                        </a>
                        <a @click="pesquisarPessoa('respdesp')" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="respdespcus">Custo</label>
                  <input id="respdespcus"
                         v-model="minutaData.respdespcus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Custo"/>
                </div>
              </div>


            </div>

            <div class="row mb-2">

              <div class="col-sm-4">
                <label for="respentr">Responsável pela Entrega</label>
                <div class="position-relative">
                  <input id="respentr"
                         type="text" v-model="minutaData.respentr"
                         class="form-control"
                         placeholder="Responsável pela Entrega" />
                  <div class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a @click="criarPessoa" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Criar Novo">
                          <i class="mdi mdi-plus-circle-outline"></i>
                        </a>
                        <a @click="pesquisarPessoa('respentr')" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                           title="Pesquisar">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="respentrcus">Custo</label>
                  <input id="respentrcus"
                         v-model="minutaData.respentrcus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Custo"/>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="respentrvei">Veículo</label>
                  <select id="respentrvei" v-model="minutaData.respentrvei" class="form-control">
                    <option :value="data.codigo" v-for="data in minutaDefVeics" :key="data.id">{{ data.descricao }}</option>
                  </select>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="respentrveicus">Custo</label>
                  <input id="respentrveicus"
                         v-model="minutaData.respentrveicus"
                         type="number"
                         class="form-control text-end"
                         placeholder="Custo"/>
                </div>
              </div>


            </div>

            <h6 class="card-title mt-4">Composição do Frete</h6>
            <hr >

            <h6 class="card-title mt-4 mb-4 text-black-50">Trecho para Cálculo do Frete</h6>

            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="trcalcori">Sigla Origem</label>
                  <input id="trcalcori"
                         v-model="minutaData.trcalcori"
                         type="text"
                         class="form-control"
                         placeholder="Sigla Origem"/>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="trcalccid">Cidade de Origem</label>
                  <div class="position-relative">
                    <input id="trcalccid"
                           type="text" v-model="minutaData.trcalccid" disabled class="form-control"
                           placeholder="Cidade de Origem" />
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a @click="pesquisarCidade('origem')"
                             href="javascript: void(0);" v-b-tooltip.hover placement="top"
                             title="Consultar Cidades">
                            <i class="mdi mdi-cloud-search-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="trcalcdest">Sigla Destino</label>
                  <input id="trcalcdest"
                         v-model="minutaData.trcalcdest"
                         type="text"
                         class="form-control"
                         placeholder="Sigla Destino"/>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="mb-3">
                  <label for="trcalcciddest">Cidade de Destino</label>
                  <div class="position-relative">
                    <input id="trcalcciddest"
                           type="text" v-model="minutaData.trcalcciddest" disabled class="form-control"
                           placeholder="Cidade de Destino" />
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a @click="pesquisarCidade('destino')"
                             href="javascript: void(0);" v-b-tooltip.hover placement="top"
                             title="Consultar Cidades">
                            <i class="mdi mdi-cloud-search-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row mb-2">

              <div class="col-sm-6">
                <div class="mb-3">
                  <label for="tabfrete">Tabela de Frete</label>
                  <input id="tabfrete"
                         v-model="minutaData.tabfrete"
                         type="text"
                         class="form-control"
                         placeholder="Tabela de Frete"/>
                </div>
              </div>

            </div>

            <h6 class="card-title mt-4">Valores</h6>
            <hr >

            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txcoleta">Taxa de Coleta (R$)</label>
                  <input id="txcoleta"
                         v-model="minutaData.txcoleta"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Coleta"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txentrega">Taxa de Entrega (R$)</label>
                  <input id="txentrega"
                         v-model="minutaData.txentrega"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Entrega"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txpedagio">Taxa de Pedágio (R$)</label>
                  <input id="txpedagio"
                         v-model="minutaData.txpedagio"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Pedágio"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txtad">Taxa de TAD (R$)</label>
                  <input id="txtad"
                         v-model="minutaData.txtad"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de TAD"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txgris">Taxa de Gris (R$)</label>
                  <input id="txgris"
                         v-model="minutaData.txgris"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Gris"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txpesoadic">Taxa de Peso Add.</label>
                  <input id="txpesoadic"
                         v-model="minutaData.txpesoadic"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Peso Add."/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txdespacho">Taxa de Despacho (R$)</label>
                  <input id="txdespacho"
                         v-model="minutaData.txdespacho"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Despacho"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txredesp">Taxa de Redespacho (R$)</label>
                  <input id="txredesp"
                         v-model="minutaData.txredesp"
                         type="number"
                         class="form-control text-end"
                         placeholder="Taxa de Redespacho"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txoutras">Outras Taxas (R$)</label>
                  <input id="txoutras"
                         v-model="minutaData.txoutras"
                         type="number"
                         class="form-control text-end"
                         placeholder="Outras Taxas"/>
                </div>
              </div>

            </div>


            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txtas">TAS (R$)</label>
                  <input id="txtas"
                         v-model="minutaData.txtas"
                         type="number"
                         class="form-control text-end"
                         placeholder="TAS"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txtrt">TRT (R$)</label>
                  <input id="txtrt"
                         v-model="minutaData.txtrt"
                         type="number"
                         class="form-control text-end"
                         placeholder="TRT"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txtde">TDE (R$)</label>
                  <input id="txtde"
                         v-model="minutaData.txtde"
                         type="number"
                         class="form-control text-end"
                         placeholder="TDE"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="txtsetcat">SET / CAT (R$)</label>
                  <input id="txtsetcat"
                         v-model="minutaData.txtsetcat"
                         type="number"
                         class="form-control text-end"
                         placeholder="SET / CAT"/>
                </div>
              </div>


            </div>


            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="advalorem">Ad. Valorem</label>
                  <input id="advalorem"
                         v-model="minutaData.advalorem"
                         type="number"
                         class="form-control text-end"
                         placeholder="Ad. Valorem"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="percnf">% NF</label>
                  <input id="percnf"
                         v-model="minutaData.percnf"
                         type="number"
                         class="form-control text-end"
                         placeholder="% NF"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="fretepeso">Frete Peso</label>
                  <input id="fretepeso"
                         v-model="minutaData.fretepeso"
                         type="number"
                         class="form-control text-end"
                         placeholder="Frete Peso"/>
                </div>
              </div>

            </div>

            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="desconto">Desconto</label>
                  <input id="desconto"
                         v-model="minutaData.desconto"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Desconto"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="acrescimo">Acréscimo</label>
                  <input id="acrescimo"
                         v-model="minutaData.acrescimo"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Acréscimo"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="aliquota">Alíquota Imposto</label>
                  <input id="aliquota"
                         v-model="minutaData.aliquota"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Alíquota Imposto"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="vlr_imposto">Valor Imposto</label>
                  <input id="vlr_imposto"
                         v-model="minutaData.vlr_imposto"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Valor Imposto"/>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="impdeduc">Dedução Imposto</label>
                  <input id="impdeduc"
                         v-model="minutaData.impdeduc"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Dedução Imposto"/>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="totalfrete">Total Frete</label>
                  <input id="totalfrete"
                         v-model="minutaData.totalfrete"
                         type="number"
                         disabled
                         class="form-control text-end"
                         placeholder="Total Frete"/>
                </div>
              </div>

            </div>



          </b-card-body>
        </b-collapse>





      </form>
    </div>




    <b-modal size="lg"
             :title="minutaDocData.id && minutaDocData.id > 0 ? `Editando Documento de Minuta (${minutaDocData.id})` : 'Criando Novo Documento de Minuta'"
             v-model="showModalMinutaDoc" centered hide-footer>

        <div class="card-body">

          <div class="row mb-3">

            <div class="col-sm-3">
              <div class="mb-3">
                <label for="minutadoctipo">Tipo</label>
                <select id="minutadoctipo" v-model="minutaDocData.tipo" class="form-control"
                        :class="{ 'is-invalid': submittedMinutaDoc && !minutaDocData.tipo }">
                  <option value="NOT">Nota Fiscal</option>
                  <option value="CTE">CT-e</option>
                  <option value="DEC">DEC</option>
                  <option value="NFE">NF-e</option>
                </select>
                <div v-if="submittedMinutaDoc && !minutaDocData.tipo" class="invalid-feedback">
                  <span>Campo tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-9">
              <label for="minutadocchave" >Chave</label>
              <div class="position-relative">
                <input id="minutadocchave"
                       type="text"
                       v-model="minutaDocData.chave" class="form-control"
                       placeholder="Chave" :class="{ 'is-invalid': submittedMinutaDoc && !minutaDocData.chave }"/>
                <div v-if="submittedMinutaDoc && !minutaDocData.chave" class="invalid-feedback">
                  <span>Campo chave obrigatório, favor preencher.</span>
                </div>
                <div class="chat-input-links" v-if="minutaDocData.chave">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a @click="consultarChaveDoc" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                         title="Consultar Chave">
                        <i class="mdi mdi-cloud-search-outline"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

          <div class="row" v-if="loadingChaveDoc">
            <div class="col-12 text-center">
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
              <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
              </b-spinner>
            </div>
          </div>

         <div v-else>

          <div class="row mb-3">





            <div class="col-md-3">
              <label for="minutadocnumero">Número</label>
              <div class="position-relative">
                <input id="minutadocnumero"
                       type="text"
                       v-model="minutaDocData.numero"
                       class="form-control"
                       placeholder="Número"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocserie">Série</label>
              <div class="position-relative">
                <input id="minutadocserie"
                       type="text"
                       v-model="minutaDocData.serie"
                       class="form-control"
                       placeholder="Série"/>
              </div>
            </div>

          </div>


          <div class="row mb-3">

            <div class="col-md-3">
              <label for="minutadocvalor">Valor</label>
              <div class="position-relative">
                <input id="minutadocvalor"
                       type="number"
                       v-model="minutaDocData.valor"
                       class="form-control text-end"
                       placeholder="Valor"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocvalorprod">Valor Produtos</label>
              <div class="position-relative">
                <input id="minutadocvalorprod"
                       type="number"
                       v-model="minutaDocData.valorprod"
                       class="form-control text-end"
                       placeholder="Valor Produtos"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadoccfop">CFOP</label>
              <div class="position-relative">
                <input id="minutadoccfop"
                       type="text"
                       v-model="minutaDocData.cfop"
                       class="form-control"
                       placeholder="CFOP"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocdata">Data Documento</label>
              <div class="position-relative">
                <input id="minutadocdata"
                       type="date"
                       v-model="minutaDocData.datadoc"
                       class="form-control"
                       placeholder="Data Documento"/>
              </div>
            </div>

          </div>


          <div class="row mb-3">

            <div class="col-md-3">
              <label for="minutadocvol">Volumes</label>
              <div class="position-relative">
                <input id="minutadocvol"
                       type="number"
                       v-model="minutaDocData.volumes"
                       class="form-control"
                       placeholder="Volumes"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocpesoreal">Peso Real</label>
              <div class="position-relative">
                <input id="minutadocpesoreal"
                       type="number"
                       v-model="minutaDocData.pesoreal"
                       class="form-control text-end"
                       placeholder="Peso Real"/>
              </div>
            </div>
          </div>


          <div class="row mb-3">

            <div class="col-sm-3">
              <div class="mb-3">
                <label for="minutadocesp">Espécie</label>
                <select id="minutadocesp" v-model="minutaDocData.especie" class="form-control"
                        :class="{ 'is-invalid': submittedMinutaDoc && !minutaDocData.tipo }">
                  <option value="DIV">Diversos</option>
                </select>
                <div v-if="submittedMinutaDoc && !minutaDocData.especie" class="invalid-feedback">
                  <span>Campo espécie obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-3">
              <label for="minutadocnatu">Natureza</label>
              <div class="position-relative">
                <input id="minutadocnatu"
                       type="text"
                       v-model="minutaDocData.natureza"
                       class="form-control"
                       placeholder="Natureza"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocpinsuframa">PIN Suframa</label>
              <div class="position-relative">
                <input id="minutadocpinsuframa"
                       type="text"
                       v-model="minutaDocData.pinsuframa"
                       class="form-control"
                       placeholder="PIN Suframa"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="minutadocpedido">Pedido</label>
              <div class="position-relative">
                <input id="minutadocpedido"
                       type="text"
                       v-model="minutaDocData.pedido"
                       class="form-control"
                       placeholder="Pedido"/>
              </div>
            </div>
          </div>



         </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalMinutaDoc = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMinutaDoc">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="minutaItemData.id && minutaItemData.id > 0 ? `Editando Item Adicional de Minuta (${minutaItemData.id})` : 'Criando Novo Item Adicional de Minuta'"
             v-model="showModalMinutaItem" centered hide-footer>

      <div class="card-body">

        <div class="row mb-3">

          <div class="col-sm-12">
            <div class="mb-3">
              <label for="minutaitemtipo">Tipo</label>
              <select id="minutaitemtipo" v-model="minutaItemData.tipo" class="form-control" @change="onTipoItemChange">
                <option :value="data.codigo" v-for="data in minutaDefItensAdics" :key="data.id">{{ data.descricao }}</option>
              </select>

            </div>
          </div>

        </div>

        <div class="row mb-2">

          <div class="col-md-9">
            <label for="minutaitemdesc">Descrição</label>
            <div class="position-relative">
              <input id="minutaitemdesc"
                     type="text"
                     v-model="minutaItemData.descricao"
                     class="form-control"
                     placeholder="Descrição" :class="{ 'is-invalid': submittedMinutaItem && !minutaItemData.descricao }" />
              <div v-if="submittedMinutaItem && !minutaItemData.descricao" class="invalid-feedback">
                <span>Campo Descrição obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <label for="minutaitemqtd">Quantidade</label>
            <div class="position-relative">
              <input id="minutaitemqtd"
                     type="number"
                     v-model="minutaItemData.quant"
                     class="form-control text-end"
                     placeholder="Quantidade" :class="{ 'is-invalid': submittedMinutaItem && !minutaItemData.quant }" />
              <div v-if="submittedMinutaItem && !minutaItemData.quant" class="invalid-feedback">
                <span>Campo quantidade obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

        </div>


        <div class="row mb-2">

          <div class="col-md-6">
            <label for="minutaitemvlrun">Valor Unitário</label>
            <div class="position-relative">
              <input id="minutaitemvlrun"
                     type="number"
                     v-model="minutaItemData.valorun"
                     class="form-control text-end"
                     placeholder="Valor Unitário" :class="{ 'is-invalid': submittedMinutaItem && !minutaItemData.valorun }" />
              <div v-if="submittedMinutaItem && !minutaItemData.valorun" class="invalid-feedback">
                <span>Campo valor unitário obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label for="minutaitemvlrtot">Valor Total</label>
            <div class="position-relative">
              <input id="minutaitemvlrtot"
                     type="number"
                     v-model="minutaItemData.valortot"
                     class="form-control text-end"
                     disabled
                     placeholder="Valor Total" :class="{ 'is-invalid': submittedMinutaItem && !minutaItemData.valortot }" />
              <div v-if="submittedMinutaItem && !minutaItemData.valortot" class="invalid-feedback">
                <span>Campo valor total obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalMinutaItem = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMinutaItem">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>




    <b-modal size="lg"
             :title="minutaLacreData.id && minutaLacreData.id > 0 ? `Editando Lacre de Minuta (${minutaLacreData.id})` : 'Criando Novo Lacre de Minuta'"
             v-model="showModalMinutaLacre" centered hide-footer>

      <div class="card-body">

        <div class="row mb-3">

          <div class="col-md-6">
            <label for="minutalacre">Lacre</label>
            <div class="position-relative">
              <input id="minutalacre"
                     type="text"
                     v-model="minutaLacreData.lacre"
                     class="form-control"
                     placeholder="Lacre" :class="{ 'is-invalid': submittedMinutaLacre && !minutaLacreData.lacre }" />
              <div v-if="submittedMinutaLacre && !minutaLacreData.lacre" class="invalid-feedback">
                <span>Campo lacre obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label for="minutalacrevol">Volume</label>
            <div class="position-relative">
              <input id="minutalacrevol"
                     type="number"
                     v-model="minutaLacreData.volume"
                     class="form-control text-end"
                     placeholder="Volume" />

            </div>
          </div>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalMinutaLacre = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMinutaLacre">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="minutaMemoData.id && minutaMemoData.id > 0 ? `Editando Memo de Minuta (${minutaMemoData.id})` : 'Criando Novo Memo de Minuta'"
             v-model="showModalMinutaMemo" centered hide-footer>

      <div class="card-body">

        <div class="row mb-3">

          <div class="col-md-12">
            <label for="minutamemo">Descrição</label>
            <div class="position-relative">
              <input id="minutamemo"
                     type="text"
                     v-model="minutaMemoData.descricao"
                     class="form-control"
                     placeholder="Descrição" :class="{ 'is-invalid': submittedMinutaMemo && !minutaMemoData.descricao }" />
              <div v-if="submittedMinutaMemo && !minutaMemoData.descricao" class="invalid-feedback">
                <span>Campo Descrição obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalMinutaMemo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confMinutaMemo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal size="xl"
             title="Pesquisar Cotação"
             v-model="showModalPesqCotacao" centered hide-footer>
      <div class="card-body">
        <ejs-grid :dataSource="cotacoesData"
                  ref="dataGridCotacoes"
                  :allowFiltering="false"
                  :allowPdfExport="true"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :enableColumnVirtualization="true"
                  :recordDoubleClick="recDblClickCotacao"
                  :dataBound="dataBoundCotacoes"
                  :toolbar="toolbar"
                  :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                  :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
          <e-columns>
            <e-column field="cnpj" headerText="CNPJ" width="120" textAlign="Left"></e-column>
            <e-column field="nome" headerText="Nome" width="150" textAlign="Left"></e-column>
            <e-column field="cepdest" headerText="CEP Fim" width="80" textAlign="Right"></e-column>
            <e-column field="ciddest" headerText="Cidade Fim" width="120" textAlign="Left"></e-column>
            <e-column field="cepori" headerText="CEP Início" width="120" textAlign="Right"></e-column>
            <e-column field="cidori" headerText="Cidade Início" width="120" textAlign="Left"></e-column>
            <e-column field="id" headerText="ID" textAlign="Right"></e-column>
          </e-columns>
        </ejs-grid>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPesqCotacao = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             title="Pesquisar Pessoas"
             v-model="showModalPesqPessoa" centered hide-footer>
      <div class="card-body">
        <ejs-grid :dataSource="pessoasData"
                  ref="dataGridPessoas"
                  :allowFiltering="false"
                  :allowPdfExport="true"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :enableColumnVirtualization="true"
                  :recordDoubleClick="recDblClickPessoa"
                  :dataBound="dataBoundPessoas"
                  :actionBegin="onActionBeginPessoa"
                  :toolbar="toolbar"
                  :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                  :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
          <e-columns>
            <e-column field="nome" headerText="Nome" textAlign="Left"></e-column>
            <e-column field="cnpj" headerText="CNPJ" width="80" textAlign="Left"></e-column>
            <e-column field="status" headerText="Status" width="20" textAlign="Left"></e-column>
            <e-column field="cidade" headerText="Cidade" width="120" textAlign="Left"></e-column>
            <e-column field="estado" headerText="Estado" width="30" textAlign="Left"></e-column>
            <e-column field="id" headerText="ID" textAlign="Right"></e-column>
          </e-columns>
        </ejs-grid>
        <div class="text-end mt-5">
          <b-button variant="outline-info" @click="criarPessoa">
            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
            Criar Nova Pessoa
          </b-button>
          <b-button variant="light" @click="showModalPesqPessoa = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl"
             title="Pesquisar Formas de Pagamento"
             v-model="showModalPesqFormaPgto" centered hide-footer>
      <div class="card-body">
        <ejs-grid :dataSource="formaPgtosData"
                  ref="dataGridFormaPgto"
                  :allowFiltering="false"
                  :allowPdfExport="true"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :enableColumnVirtualization="true"
                  :recordDoubleClick="recDblClickFormaPgto"
                  :dataBound="dataBoundFormPgtos"
                  :actionBegin="onActionBeginFormPgto"
                  :toolbar="toolbar"
                  :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                  :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
          <e-columns>
            <e-column field="id" headerText="ID" width="80" textAlign="Right"></e-column>
            <e-column field="codigo" headerText="Código" width="80" textAlign="Left"></e-column>
            <e-column field="descricao" headerText="Descrição" textAlign="Left"></e-column>
            <e-column field="status" headerText="Status" width="20" textAlign="Left"></e-column>
          </e-columns>
        </ejs-grid>
        <div class="text-end mt-5">
          <b-button variant="outline-info" @click="criarFormaPgto">
            <i class="bx bxs-book-open font-size-16 align-middle me-2"></i>
            Abrir Cadastro de Formas de Pagamento
          </b-button>
          <b-button variant="light" @click="showModalPesqFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl"
             title="Pesquisar Bases"
             v-model="showModalPesqEmpresa" centered hide-footer>
      <div class="card-body">
        <ejs-grid :dataSource="empresasData"
                  ref="dataGridEmpresa"
                  :allowFiltering="false"
                  :allowPdfExport="true"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :enableColumnVirtualization="true"
                  :recordDoubleClick="recDblClickEmpresa"
                  :dataBound="dataBoundEmpresas"
                  :actionBegin="onActionBeginEmpresa"
                  :toolbar="toolbar"
                  :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                  :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
          <e-columns>
            <e-column field="id" headerText="ID" width="30" textAlign="Right"></e-column>
            <e-column field="codigo" headerText="Código" width="30" textAlign="Right"></e-column>
            <e-column field="nome" headerText="Descrição" textAlign="Left"></e-column>
            <e-column field="status" headerText="Status" width="20" textAlign="Left"></e-column>
            <e-column field="cidade" headerText="Cidade" width="120" textAlign="Left"></e-column>
          </e-columns>
        </ejs-grid>
        <div class="text-end mt-5">
          <b-button variant="outline-info" @click="abrirEmpresas">
            <i class="bx bxs-book-open font-size-16 align-middle me-2"></i>
            Abrir Cadastro de Empresas
          </b-button>
          <b-button variant="light" @click="showModalPesqFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl"
             title="Pesquisar Cidades"
             v-model="showModalPesqCidade" centered hide-footer>
      <div class="card-body">
        <ejs-grid :dataSource="cidadesData"
                  ref="dataGridCidades"
                  :allowFiltering="false"
                  :allowPdfExport="true"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :enableColumnVirtualization="true"
                  :recordDoubleClick="recDblClickCidade"
                  :dataBound="dataBoundCidades"
                  :actionBegin="onActionBeginCidade"
                  :toolbar="toolbar"
                  :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                  :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
          <e-columns>
            <e-column field="id" headerText="ID" width="30" textAlign="Right"></e-column>
            <e-column field="codigo" headerText="Código" width="30" textAlign="Right"></e-column>
            <e-column field="descricao" headerText="Cidade" textAlign="Left"></e-column>
            <e-column field="estado" headerText="Estado" textAlign="Left"></e-column>
          </e-columns>
        </ejs-grid>
        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalPesqCidade = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>




  </Layout>
</template>

